import View from 'src/components/shared/view';
import domSelector from 'src/utils/domSelector';

import email from 'src/templates/input/partials/email.hbs';
import firstname from 'src/templates/input/partials/firstname.hbs';
import password from 'src/templates/input/partials/password.hbs';
import privacy from 'src/templates/input/partials/privacy.hbs';
import newsletter from 'src/templates/input/partials/newsletter.hbs';

const TEMPLATES = {
  email,
  firstname,
  password,
  privacy,
  newsletter
};

const INVALID_CLASSNAME = 'invalid';

class PartialInputView extends View {
  constructor({ body, templateScope }) {
    super();
    this.body = body;
    this.templateScope = templateScope;
    this.resetError = this.resetError.bind(this);
    this.render();
    this.bindEvents();
  }

  render() {
    const { inputName } = this.templateScope;
    const partialSubView = domSelector.getInputPartialSelector(inputName);
    const templateScopeWithSelectors = Object.assign(this.templateScope, { partialSubView });

    const renderedTemplate = TEMPLATES[inputName](templateScopeWithSelectors);
    this.appendToBody(renderedTemplate);

    this.container = domSelector.getInputPartialContainer(inputName);
    this.inputElement = this.container.querySelector('[data-partial-input]');
    this.validationElement = this.container.querySelector('[data-partial-validation]');
    if (this.inputIsInvalid()) this.selectInputText();
  }

  /*
   * bindEvents() track clicks on social buttons,
   * only reset errors for non-social input(input fields)
  */
  bindEvents() {
    this.inputElement.addEventListener('click', this.resetError);
  }

  resetError() {
    this.inputElement.className = this.inputElement.className.replace(INVALID_CLASSNAME, '').trim();
    this.validationElement.innerHTML = '';
  }

  getInputKeyAndValue() {
    const value = (this.inputElement && this.inputElement.value) ? this.inputElement.value : '';
    return { [this.templateScope.inputName]: value };
  }

  inputIsInvalid() {
    return this.inputElement.className.includes(INVALID_CLASSNAME);
  }

  inputIsEmpty() {
    return this.inputElement.value === '';
  }

  selectInputText() {
    this.inputElement.select();
  }

  shouldFocus() {
    return this.inputIsInvalid() || this.inputIsEmpty();
  }

  destroy() {
    this.inputElement.removeEventListener('click', this.resetError);
    this.body.removeChild(this.container);
    this.container = null;
    this.inputElement = null;
    this.validationElement = null;
  }
}

export default PartialInputView;
